<main class="condo-page">
  <!-- HERO -->
  <section class="page-hero">
    <div class="container-xl pt-navfix">
      <div class="hero-card card-sami">
        <div class="row align-items-center g-4">
          <div class="col-12 col-lg-7">
            <h1 class="fw-bold mb-2">Pulizia condomini a Pescara</h1>
            <p class="mb-0 hero-sub">
              Con <strong>SAMI Pulizie</strong> garantisci al tuo condominio un
              ambiente sempre pulito e curato. Interveniamo su
              <strong>scale, pianerottoli, ascensori, vetrate e aree comuni</strong>
              con personale qualificato e prodotti professionali.
            </p>

            <div class="d-flex flex-wrap gap-2 mt-3">
              <button class="btn-sami" (click)="navigateToPreventiviSito()">
                Richiedi sopralluogo gratuito
              </button>
              <a class="btn-sami-outline" href="tel:08554360">Chiama ora</a>
            </div>

            <div class="hero-chips mt-4">
              <div class="chip">
                <i class="fa-solid fa-people-group"></i> Team affidabile
              </div>
              <div class="chip">
                <i class="fa-solid fa-clock"></i> Orari concordati
              </div>
              <div class="chip">
                <i class="fa-solid fa-spray-can-sparkles"></i> Prodotti certificati
              </div>
            </div>
          </div>

          <div class="col-12 col-lg-5">
            <div class="hero-media">
              <img
                src="assets/condomini-portoni-ascensori.webp"
                class="hero-img"
                alt="Pulizia aree comuni condominiali"
                loading="eager"
                fetchpriority="high"
                decoding="async"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>

  <!-- SERVIZI PER CONDOMINI + AREE DI INTERVENTO -->
  <section class="section">
    <div class="container-xl">
      <div class="row g-4 align-items-start">
        <div class="col-12 col-lg-7">
          <h2 class="fw-bold mb-3">Servizi per condomini</h2>

          <p class="text-muted mb-3">
            Un condominio pulito e ben tenuto aumenta il valore dell’immobile e
            migliora la qualità della vita dei residenti. Offriamo piani di
            pulizia programmati e personalizzati in base alle esigenze.
          </p>

          <p class="text-muted mb-4">
            Lavoriamo con amministratori e comitati condominiali con report e
            massima trasparenza. Il nostro personale è puntuale, rispettoso e
            attento agli spazi comuni.
          </p>

          <ul class="checklist">
            <li><i class="fa-solid fa-check"></i> Pulizia scale e pianerottoli</li>
            <li><i class="fa-solid fa-check"></i> Lavaggio pavimenti e superfici comuni</li>
            <li><i class="fa-solid fa-check"></i> Pulizia ascensori</li>
            <li><i class="fa-solid fa-check"></i> Pulizia e sanificazione androni</li>
            <li><i class="fa-solid fa-check"></i> Pulizia cortili e aree esterne</li>
            <li><i class="fa-solid fa-check"></i> Svuotamento cestini</li>
            <li><i class="fa-solid fa-check"></i> Pulizia vetrate comuni</li>
            <li><i class="fa-solid fa-check"></i> Pulizia garage e cantine</li>
            <li><i class="fa-solid fa-check"></i> Manutenzione aree verdi condominiali</li>
            <li><i class="fa-solid fa-check"></i> Servizio invernale (spalamento neve)</li>
          </ul>
        </div>

        <div class="col-12 col-lg-5">
          <div class="card-sami p-4">
            <h3 class="fw-bold mb-3">Aree di intervento</h3>

            <ul class="bullets">
              <li>Scale e pianerottoli</li>
              <li>Androni di ingresso</li>
              <li>Ascensori</li>
              <li>Cortili interni</li>
              <li>Giardini condominiali</li>
              <li>Garage e box</li>
              <li>Locali caldaia</li>
              <li>Depositi comuni</li>
            </ul>

            <div class="note-box mt-3">
              <strong>Nota:</strong> interveniamo su tutte le aree comuni del
              condominio, adattando il servizio alle specifiche necessità e al
              regolamento condominiale.
            </div>

            <div class="mini-cta mt-3">
              <div class="mini-cta-title">Vuoi un piano su misura?</div>
              <div class="mini-cta-text">
                Sopralluogo gratuito e preventivo personalizzato.
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>

  <!-- COME FUNZIONA -->
  <section class="section section-soft">
    <div class="container-xl">
      <div class="process-wrap card-sami">
        <h2 class="text-center fw-bold mb-4">Come funziona</h2>

        <div class="row row-cols-1 row-cols-md-2 row-cols-xl-4 g-3">
          <div class="col">
            <div class="process-step">
              <div class="step-num">1</div>
              <div class="step-title">Sopralluogo</div>
              <div class="step-text">
                Visitiamo il condominio per valutare aree e necessità.
              </div>
            </div>
          </div>

          <div class="col">
            <div class="process-step">
              <div class="step-num">2</div>
              <div class="step-title">Preventivo</div>
              <div class="step-text">
                Creiamo un piano personalizzato con preventivo dettagliato.
              </div>
            </div>
          </div>

          <div class="col">
            <div class="process-step">
              <div class="step-num">3</div>
              <div class="step-title">Attivazione</div>
              <div class="step-text">Firmiamo il contratto e avviamo il servizio.</div>
            </div>
          </div>

          <div class="col">
            <div class="process-step">
              <div class="step-num">4</div>
              <div class="step-title">Monitoraggio</div>
              <div class="step-text">Report periodici e assistenza continua.</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>

  <!-- CTA -->
  <section class="section-cta cta-wide">
    <div class="container-xl text-center">
      <h2 class="cta-title">Il tuo condominio merita il meglio</h2>
      <p class="cta-text">
        Contattaci per un sopralluogo gratuito e un preventivo personalizzato senza
        impegno.
      </p>

      <div class="d-flex justify-content-center gap-2 flex-wrap mt-3">
        <button class="btn btn-light cta-btn" (click)="navigateToPreventiviSito()">
          Richiedi sopralluogo gratuito
        </button>
        <a class="btn btn-outline-light cta-btn" href="tel:08554360">
          Chiama 085 54360
        </a>
      </div>
    </div>
  </section>

  <!-- MAPPA -->
  <section class="section">
    <div class="container-xl">
      <div class="section-head text-center">
        <h2 class="fw-bold">Dove operiamo</h2>
        <p class="text-muted mb-0">Sede commerciale: Via Tirino 145, Pescara.</p>
      </div>

      <div class="col-12 col-md-10 col-lg-8 mx-auto mt-3">
        <div class="ratio ratio-16x9 map-shell">
          <iframe
            loading="lazy"
            allowfullscreen
            style="border:0;"
            referrerpolicy="no-referrer-when-downgrade"
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2843.2073!2d14.2181475!3d42.4462893!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x1331a6223b8afae7%3A0xe0f8329b5888d54d!2sVia%20Tirino%2C%20145%2C%20Pescara!5e0!3m2!1sit!2sit!4v1713538014550"
          ></iframe>
        </div>
      </div>
    </div>
  </section>

  <!-- WhatsApp -->
  <div class="position-fixed bottom-0 end-0 mb-4 me-4" style="z-index:1050;">
    <a
      href="https://wa.me/3515034934"
      target="_blank"
      rel="noopener noreferrer"
      class="btn btn-success rounded-circle btn-sm"
      aria-label="Chatta su WhatsApp"
    >
      <i class="fa-brands fa-whatsapp fa-2x"></i>
    </a>
  </div>
</main>
